export const passportEn = {
  passport: {
    title: "Digital Parcel Record",
    subtitle: "Complete parcel lifecycle digital record signed with a cryptographic hash (SHA-256), optionally anchored on Polygon. Not an officially issued certificate.",
    generate: "Generate Passport",
    generated: "Passport generated",
    generatedDesc: "Digital passport created with SHA-256 hash",
    certificateReady: "Digital record ready",
    blockchainReady: "Blockchain Ready",
    anchorBlockchain: "Anchor on Blockchain",
    anchored: "Anchored on Blockchain",
    climateRecords: "Climate Records",
    cropSeasons: "Crop Seasons",
    fieldActivities: "Field Activities",
    alerts: "Alerts & Incidents",
    resolved: "resolved",
    tabIdentity: "Identity",
    tabClimate: "Climate",
    tabVegetation: "Vegetation",
    tabWater: "Water Balance",
    tabActivities: "Activities",
    tabPests: "Pests",
    tabCerts: "Certifications",
    parcelIdentity: "Parcel Identity",
    name: "Name",
    cropType: "Crop Type",
    area: "Area",
    soilType: "Soil Type",
    irrigationType: "Irrigation Type",
    plantingDate: "Planting Date",
    lat: "Latitude",
    lon: "Longitude",
    registeredSince: "Registered since",
    climateHistory: "Climate History",
    last90days: "Last 90 days of weather data",
    vegetationIndices: "Vegetation Indices",
    waterBalance: "Water Balance & Crop Coefficients",
    fieldActivitiesTitle: "Field Activity Log",
    recordedActivities: "recorded activities",
    pestsDiseasesTitle: "Pest & Disease Treatments",
    noPests: "No pest treatments recorded — excellent track record!",
    previousCerts: "Previous Certifications",
    ndviFromActivities: "NDVI recorded from field activities",
    activity: "Activity",
    before: "Before",
    after: "After",
    howToUseTitle: "How to use your Digital Passport?",
    howStep1Title: "Data integrity",
    howStep1: "The SHA-256 hash ensures data cannot be altered. Any change produces a different hash.",
    howStep2Title: "Anchor on blockchain",
    howStep2: "Optionally anchor selected certificate hashes on Polygon to add an independent public timestamp. Anchoring is opt-in and only applied to selected certificates.",
    howStep3Title: "Insurance & audits",
    howStep3: "Present your passport as evidence for insurance claims, PAC/CAP audits, or quality certifications.",
    howStep4Title: "Prefinancing",
    howStep4: "A documented, hash-traceable history increases buyer and investor trust in your production.",
    verifyLink: "Verify this digital record publicly",
    shareVerification: "Share Verification Link",
    copied: "Verification link copied!",
    institutional: {
      title: "Evidence Passport",
      artifactType: "Crop Season Evidence Snapshot",
      description: "A point-in-time record of the evidence available for this parcel and crop season. It distinguishes observations, declarations, model outputs and missing evidence.",
      ownerOnly: "Authenticated owner view",
      selectRecord: "Select an evidence record",
      cropSeason: "Crop season",
      selectSeason: "Select a crop season",
      snapshotHistory: "Snapshot history",
      selectSnapshot: "Select a snapshot",
      latest: "Latest",
      loadingSnapshots: "Loading stored snapshots…",
      emptyTitle: "No Evidence Snapshot is available for this crop season.",
      emptyDescription: "This view does not create snapshots automatically.",
      summaryTitle: "Evidence summary",
      entriesTitle: "Evidence entries",
      entriesDescription: "Expand an entry to inspect its stored source, provenance, quality and limitations.",
      missingTitle: "Missing evidence",
      missingDescription: "Evidence that was unavailable, insufficiently proven, stale, unsupported or blocked at the snapshot time remains explicitly missing.",
      notAvailable: "Not available in this snapshot",
      limitationsTitle: "Limitations",
      limitationsDescription: "Complete stored limitations for this immutable snapshot.",
      integrityTitle: "Record integrity",
      integrityClaim: "The SHA-256 digest allows SentinelCrop to detect whether this stored snapshot payload differs from the payload represented by the digest.",
      integrityBoundary: "This digest does not establish agricultural truth, field validation, declaration accuracy, measurement accuracy, yield, harvest, commodity existence, chain of custody, carbon outcomes or third-party certification.",
      digestMatch: "Payload digest matches stored hash",
      digestMatchDescription: "The browser canonicalized the returned stored snapshot payload with the existing integrity contract and reproduced the stored digest.",
      digestWarning: "Payload integrity warning",
      digestWarningDescription: "The returned stored payload did not reproduce the stored digest. Reason: {{reason}}. The snapshot was not altered.",
      digestChecking: "Checking payload digest",
      digestCheckingDescription: "Canonicalizing the returned stored payload and comparing its digest.",
      byClass: "By evidence class",
      byOrigin: "By evidence origin",
      noneRecorded: "None recorded in this snapshot.",
      unknown: "Unknown",
      canonicalSemantics: "Canonical semantics",
      fields: {
        contractVersion: "Contract version", attribute: "Attribute", value: "Stored value", unit: "Unit",
        entryClass: "Evidence class", evidenceOrigin: "Evidence origin",
        verificationStatus: "Verification status", sourceSystem: "Source", sourceRecordId: "Source record ID",
        observedAt: "Observed at", recordedAt: "Recorded at", quality: "Quality level", qualityNotes: "Quality notes",
        valueReference: "Value reference", reason: "Reason", expectedSource: "Expected source", cropSeason: "Crop season",
        cropSeasonStart: "Crop season start", snapshotId: "Snapshot ID", snapshotVersion: "Snapshot version",
        asOf: "Snapshot as of", createdAt: "Created at", integrityAlgorithm: "Integrity algorithm", integrityHash: "Complete integrity hash",
      },
      enums: {
        FACT_OBSERVATION: "Fact observation", DECLARATION: "Declaration", REFERENCE_DATA: "Reference data",
        MODEL_OUTPUT: "Model output", HUMAN_REVIEW: "Human review", MISSING_UNKNOWN: "Missing / unknown",
        SATELLITE_VERIFIED: "Satellite verified", FIELD_MEASURED: "Field measured", LAB_VERIFIED: "Lab verified",
        DOCUMENT_VERIFIED: "Document verified", PRODUCER_DECLARED: "Producer declared", MODELLED: "Modelled",
        NOT_VERIFIED: "Not verified", SOURCE_BACKED: "Source backed", SELF_REPORTED: "Self-reported",
        REFERENCE_ONLY: "Reference only", UNVERIFIED: "Unverified", BLOCKED: "Blocked",
        NO_SOURCE_RECORD: "No source record", STALE: "Stale", BLOCKED_BY_CONTRACT: "Blocked by contract",
        INSUFFICIENT_PROVENANCE: "Insufficient provenance", UNSUPPORTED_SOURCE: "Unsupported source", NEVER_COLLECTED: "Never collected",
        high: "High", medium: "Medium", low: "Low", unknown: "Unknown", planning: "Planning", active: "Active",
        harvested: "Harvested", cancelled: "Cancelled",
      },
      limitations: {},
      errors: {
        authRequired: "An authenticated owner session is required.", parcels: "Parcels could not be loaded.",
        seasons: "Crop seasons could not be loaded.", snapshots: "Stored Evidence Snapshots could not be loaded.",
      },
    },
  },
  verify: {
    authority: "Algorithm Provider",
    title: "Digital Record Verification",
    subtitle: "Enter a SHA-256 hash to verify the integrity of a Sentinel Crop digital record. This is a data-integrity check, not an official certificate verification.",
    placeholder: "0x... (SHA-256 hash)",
    verify: "Verify",
    verified: "Digital Record Verified ✓",
    verifiedDesc: "This digital record was generated by Sentinel Crop and its data has not been altered since issuance. Sentinel Crop is not a certification authority.",
    notVerified: "Digital Record Not Found",
    notVerifiedDesc: "No record matches this hash. It may have been altered or does not exist.",
    certType: "Record Type",
    issuedAt: "Issued At",
    issuer: "Algorithm Provider",
    certId: "Record ID",
    dataHash: "Data Integrity Hash (SHA-256)",
    parcelInfo: "Registered Parcel",
    blockchainProof: "Blockchain Proof",
    network: "Network",
    blockNumber: "Block Number",
    txHash: "Transaction Hash",
    viewOnExplorer: "View on Polygonscan",
    howItWorks: "How does verification work?",
    step1: "All agronomic data is hashed using SHA-256, creating a unique cryptographic fingerprint.",
    step1b: "Each certificate includes the original data source IDs (Copernicus, AEMET, SoilGrids) so anyone can independently verify the raw data.",
    step2: "The hash can be optionally anchored on the Polygon network for selected certificates, adding an independent public timestamp.",
    step3: "Anyone with the hash can verify that the data has not been altered since certification.",
    provenanceTitle: "Data Sources & Independent Verification",
    provenanceDesc: "Each data source below can be independently verified by clicking the external link. Don't trust — verify.",
    srcSatellite: "Satellite Imagery",
    srcWeather: "Weather & Meteorological Data",
    srcSoil: "Soil Data",
    srcAlgorithm: "Calculation Algorithm",
    verifySource: "Verify ↗",
    lastAcquisition: "Last acquisition",
    resolution: "Resolution",
    footerTrust: "Don't trust. Verify. — All data sources are independently auditable.",
  },
};
